module.exports = __webpack_public_path__ + "static/media/react_logo.e5c4f4e7.png";